/* eslint-disable react/jsx-props-no-spreading */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import { mergeCkeditorConfig } from 'constants/ckeditor';

const HEADING_OPTIONS = [
  { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
  {
    model: 'heading1',
    view: 'h1',
    title: 'Heading 1',
    class: 'ck-heading_heading1',
  },
  {
    model: 'heading2',
    view: 'h2',
    title: 'Heading 2',
    class: 'ck-heading_heading2',
  },
  {
    model: 'heading3',
    view: 'h3',
    title: 'Heading 3',
    class: 'ck-heading_heading3',
  },
  {
    model: 'heading4',
    view: 'h4',
    title: 'Heading 4',
    class: 'ck-heading_heading4',
  },
  {
    model: 'heading5',
    view: 'h5',
    title: 'Heading 5',
    class: 'ck-heading_heading5',
  },
  {
    model: 'heading6',
    view: 'h6',
    title: 'Heading 6',
    class: 'ck-heading_heading6',
  },
];

const RichTextEditor = ({
  handleInputChange,
  config,
  data = '',
  disableDebounce = false,
  ...otherProps
}) => {
  const editorConfig = useMemo(() => {
    const merged = mergeCkeditorConfig(config);

    return {
      ...merged,
      heading: {
        ...merged.heading,
        options: HEADING_OPTIONS,
      },
    };
  }, [config]);

  const debounceFunc = useMemo(
    () => _.debounce((_data) => handleInputChange(_data), 500),
    [handleInputChange],
  );

  const handleChange = useCallback(
    (event, editor) => {
      if (disableDebounce) {
        handleInputChange(editor.getData());
      } else {
        debounceFunc(editor.getData());
      }
    },
    [disableDebounce, handleInputChange, debounceFunc],
  );

  return (
    <CKEditor
      {...otherProps}
      config={editorConfig}
      editor={ClassicEditor}
      data={data}
      onChange={handleChange}
    />
  );
};

RichTextEditor.propTypes = {
  config: PropTypes.shape({
    heading: PropTypes.shape({}),
  }),
  data: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  disableDebounce: PropTypes.bool,
};

export default React.memo(RichTextEditor);
